import { Component } from '@angular/core';
import { FieldWrapper, FormlyFieldConfig, FormlyFieldProps as CoreFormlyFieldProps, FormlyValidationMessage } from '@ngx-formly/core';

export interface FormlyFieldProps extends CoreFormlyFieldProps {
  hideRequiredMarker?: boolean;
  hideLabel?: boolean;
}

@Component({
  selector: 'formly-wrapper-center',
  standalone: true,
  imports: [FormlyValidationMessage],
  template: `
    @if (props.label && props.hideLabel !== true) {
      <label class="mb-2 block" [for]="id">
        {{ props.label }}
        @if (props.required && props.hideRequiredMarker !== true) {
          <span aria-hidden="true" class="text-red-500 ml-1">*</span>
        }
      </label>
    }

    <ng-container #fieldComponent></ng-container>

    @if (showError) {
      <small class="p-error block mt-1">
        <formly-validation-message class="ui-message-text" [field]="field"></formly-validation-message>
      </small>
    }
  `,
})
export class FormlyCenterWrapper extends FieldWrapper<FormlyFieldConfig<FormlyFieldProps>> {
}
